import React, { Component } from 'react';
import { object } from "prop-types";
import './TimesheetEntry.css';

class TimesheetHeader extends Component {
  static PropTypes = {
    user: object
  }

  render() {
    return (
      <tr className="timesheetEntryHeader">
        <td colSpan={2}>{this.props.user.first_name} {this.props.user.last_name}</td>
        <td className="timesheetEntryDataWD">Mon</td>
        <td className="timesheetEntryDataWD">Tue</td>
        <td className="timesheetEntryDataWD">Wed</td>
        <td className="timesheetEntryDataWD">Thu</td>
        <td className="timesheetEntryDataWD">Fri</td>
        <td className="timesheetEntryDataWD">Sat</td>
        <td className="timesheetEntryDataWD">Sun</td>
      </tr>
    );
  }
}

export default TimesheetHeader;


// WEBPACK FOOTER //
// ./src/components/main/timesheet/_common/TimesheetHeader.js